import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import InstallHint from '../common/InstallHint';
import MobileBottomBar from '../common/MobileBottomBar';

// Shared shell for the Trainer and Student portals — mirrors AdminLayout.
function PortalLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background">
      <Navbar onMenuToggle={() => setSidebarOpen(prev => !prev)} />
      <div className="flex">
        {sidebarOpen && (
          <div
            className="fixed inset-0 bg-black/40 z-40 lg:hidden"
            onClick={() => setSidebarOpen(false)}
          />
        )}
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        <main className="flex-1 p-4 sm:p-6 pb-20 md:pb-6 overflow-auto min-w-0">
          <Outlet />
        </main>
      </div>
      <MobileBottomBar onMenuToggle={() => setSidebarOpen(prev => !prev)} />
      <InstallHint />
    </div>
  );
}

export default PortalLayout;
